export const parsePositiveInteger = (value: string | null): number | undefined => {
  const parsedValue = Number(value);
  if (!Number.isInteger(parsedValue) || parsedValue <= 0) return undefined;
  return parsedValue;
};

export default parsePositiveInteger;
